import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const FRAMES = Array.from({ length: 8 }, (_, i) => `/hero/mc20-${i}.webp`);
const VIDEO = "/hero/mc20-turntable.mp4";
const STEP_MS = 900;
const BOX = "absolute aspect-video w-[118%] left-1/2 -translate-x-1/2 top-[12%] md:w-[72%] md:left-auto md:translate-x-0 md:right-[-4%] md:top-1/2 md:-translate-y-[44%] [mask-image:radial-gradient(ellipse_50%_50%_at_center,black_68%,transparent_100%)]";
const FILL = "absolute inset-0 w-full h-full object-cover";

function FrameSpin() {
  const [i, setI] = useState(1);
  useEffect(() => {
    FRAMES.forEach((src) => { const img = new Image(); img.src = src; });
    const t = setInterval(() => setI((n) => (n + 1) % FRAMES.length), STEP_MS);
    return () => clearInterval(t);
  }, []);
  return (
    <AnimatePresence initial={false}>
      <motion.img key={i} src={FRAMES[i]} alt="Maserati MC20" className={FILL}
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.75 }} data-testid={`hero-frame-${i}`} />
    </AnimatePresence>
  );
}

export function CarSpin({ still = false }) {
  const [videoFailed, setVideoFailed] = useState(false);
  if (still) {
    return <div className={BOX}><img src={FRAMES[1]} alt="Maserati MC20" className={FILL} data-testid="hero-poster" /></div>;
  }
  return (
    <div className={BOX} data-testid="hero-spin">
      {videoFailed ? <FrameSpin /> : (
        <video className={FILL} src={VIDEO} poster="/hero/mc20-turntable-poster.jpg" autoPlay muted loop playsInline preload="auto"
          onError={() => setVideoFailed(true)} data-testid="hero-video" />
      )}
    </div>
  );
}
